import { render } from "./reviewRewardTable.vue?vue&type=template&id=753c945e&scoped=true"
import script from "./reviewRewardTable.vue?vue&type=script&lang=js"
export * from "./reviewRewardTable.vue?vue&type=script&lang=js"

import "./reviewRewardTable.vue?vue&type=style&index=0&id=753c945e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753c945e"]])

export default __exports__